export const wrapResponse = ({ data = [], included = [] }) => ({
  data,
  included,
  jsonapi: {
    version: '1.0',
  },
})
